import type { RootState } from '../../../stores/store';

export const setAlertSelector = (state: RootState) => state.setAlertsDevices;
